import { Service, ServiceGroup } from "../../model"
import { isServiceBudgetEvolution } from "./counter-domain";

export function contains(services: Service[], service: Service): boolean {
	return services.some(s => s && service && s.id === service.id)
}

export function filterServicesBySlugs(services: Service[], slugs: string[]): Service[] {
	return services.filter(s => s && slugs.some(slug => slug === s.slug))
}

export function findServicesByGroup(group: ServiceGroup, services: Service[]): Service[] {
	if (group && group.services && group.services.length) {
		return services.filter(service => service.serviceGroup === group.id)
	}
}

export function getService(services: Service[], slug: string): Service|null {
	return services.find(s => s.slug === slug) || null
}

export function findServiceById(services: Service[], id: number): Service|null {
	return services.find(s => s.id === id) || null
}

export function sortServices(services: Service[], key: keyof Service = "label"): void {
	services.sort((a, b) => a[key] >= b[key] ? 1 : -1)
}

export function isService(param: any): param is Service {
	return undefined !== (param as Service)
}

export function isServiceArray(param: any): param is Service[] {
	return undefined !== (param as Service[])
}


// WEBPACK FOOTER //
// ./src/domain/sfp/service-domain.ts